import type { JobStatus } from "../schemas/job";

export const JOB_LIST_STATUS_FILTERS = [
  { id: "all", label: "All sites" },
  { id: "active", label: "Active" },
  { id: "complete", label: "Complete" },
  { id: "archived", label: "Archived" },
] as const;

export type JobListStatusFilterId =
  (typeof JOB_LIST_STATUS_FILTERS)[number]["id"];

export type JobListFilters = {
  query: string;
  status: JobListStatusFilterId;
};

export type JobListFilterRow = {
  name: string;
  address?: string | null;
  status?: JobStatus | string | null;
  deletedAt?: string | null;
  ownerName?: string | null;
};

/** Status pill on job list rows (web dashboard cards and mobile JobCard). */
export function jobListDisplayStatus(job: JobListFilterRow): string | null {
  if (job.deletedAt || job.status === "archived") return "Archived";
  if (job.status === "complete") return "Complete";
  return null;
}

export function filterJobListRows<T extends JobListFilterRow>(
  jobs: T[],
  filters: JobListFilters,
): T[] {
  const q = filters.query.trim().toLowerCase();

  return jobs.filter((job) => {
    if (filters.status !== "all") {
      if (filters.status === "archived") {
        if (job.deletedAt) return true;
        if ((job.status ?? "active") !== "archived") return false;
      } else if (job.deletedAt) {
        return false;
      } else if ((job.status ?? "active") !== filters.status) {
        return false;
      }
    } else if (job.deletedAt) {
      return false;
    }

    if (!q) return true;
    return [job.name, job.address, job.ownerName]
      .filter(Boolean)
      .some((value) => String(value).toLowerCase().includes(q));
  });
}
